import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import { BLOCKS } from 'hb-react/frontoffice/components/BlocksRenderer/shared';
import oneColumnTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/OneColumnTemplate';
import twoColumnsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/TwoColumnsTemplate';
import {
  NO_ZONE,
  withCustomZones,
} from 'hb-react/frontoffice/components/BlocksRenderer/templates/utils';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';

const TEMPLATES = {
  [oneColumnTemplate.id]: oneColumnTemplate,
  [twoColumnsTemplate.id]: withCustomZones(twoColumnsTemplate, {
    [NO_ZONE]: [BLOCKS.side.id],
  }),
};

export const useWhichTemplate = () => {
  const { appPageConfig } = useForumContext();
  const { topicId } = useTopicContext();

  if (topicId) {
    return TEMPLATES[twoColumnsTemplate.id];
  }

  const templateId =
    appPageConfig?.config?.blocks_renderer_template || twoColumnsTemplate.id;

  return TEMPLATES[templateId];
};
